module.exports = __webpack_public_path__ + "static/sacred_statue-22272876750fec052e9ac8f3da25fb1f.png";